import {
  SEND_BULK_SMS_ERROR,
  SEND_BULK_SMS_START,
  SEND_BULK_SMS_SUCCESS,
} from 'constants/action-types/organizations/bulkSms';

export default (state, { type, payload }) => {
  switch (type) {
    case SEND_BULK_SMS_START:
      return {
        ...state,
        bulkSms: {
          ...state.bulkSms,
          loading: true,
          error: null,
        },
      };
    case SEND_BULK_SMS_ERROR:
      return {
        ...state,
        bulkSms: {
          ...state.bulkSms,
          error: payload,
          loading: false,
        },
      };
    case SEND_BULK_SMS_SUCCESS:
      return {
        ...state,
        bulkSms: {
          ...state.bulkSms,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
